// Texts of the shared shell; apps merge them into their vue-i18n messages under `shell`.
export const shellMessages = {
  'pt-BR': {
    shell: {
      navigation: 'Navegação',
      openMenu: 'Abrir menu',
      closeMenu: 'Fechar menu',
      collapseMenu: 'Recolher menu',
      expandMenu: 'Expandir menu',
      filterMenu: 'Buscar no menu…',
      filterMenuLabel: 'Filtrar os itens do menu',
      filterMenuEmpty: 'Nenhum item do menu corresponde a “{query}”.',
      userMenu: 'Menu do usuário {name}',
      darkMode: 'Modo escuro',
      lightMode: 'Modo claro',
      switchToDark: 'Ativar modo escuro',
      switchToLight: 'Ativar modo claro',
      logout: 'Sair',
      signingIn: 'Entrando',
      errors: {
        network: 'Sem conexão com o servidor. Verifique sua internet e tente novamente.',
        forbidden: 'Você não tem permissão para esta ação.',
        notFound: 'Não encontramos o que você procurava.',
        conflict: 'Não foi possível concluir: há um conflito com os dados atuais.',
        validation: 'Revise os campos destacados.',
        server: 'O serviço não respondeu como esperado. Tente novamente em instantes.',
        generic: 'Não foi possível concluir a operação.',
      },
      status: {
        forbiddenTitle: 'Você não tem acesso a esta página',
        forbiddenText: 'Peça acesso a quem administra a sua empresa. Se acha que é um engano, saia e entre de novo.',
        notFoundTitle: 'Página não encontrada',
        notFoundText: 'O endereço pode ter mudado ou a página foi removida.',
        errorTitle: 'Algo deu errado',
        errorText: 'Não foi possível concluir a operação. Tente novamente em instantes.',
        backHome: 'Voltar ao início',
        reference: 'Código para o suporte: {id}',
      },
    },
  },
} as const
